/**
 * This is the-header-search script.js file
 */
import { generateTabPayload } from '@/use/menu.space';
import DispatchersMixin from '@/mixins/dispatchers';

export default {
    name : 'the-header-search',
    mixins: [DispatchersMixin],
    /**
     * @override
     */
    data() {
        return {
            search: '',
            results: [],
            type: '',
            searching: false,
            timeOutSearch: null,
            timeOutSearchTime: 1000
        };
    },
    methods: {
        allowExternalCodesFromSystemMappings() {
            return this.$store.getters['configVarsStore/getAllowExternalCodesFromSM'];
        },
        onSelectSearch(object) {
            const item = generateTabPayload(object.tabName, `${object.type}_uuid`, { name: object.tabName, uuid: object.uuid });
            this.setMenuTab(item);
            this.searching = false;
        },
        loadInterveners(response) {
            this.results[0].objs = [];
            response.data.interveners.forEach(element => {
                this.results[0].objs.push({
                    uuid: element.uuid,
                    displayName: `${element.id_object} - ${element.name} ${element.lastname_1} - ${element.document_id}`,
                    tabName: `${element.name} ${element.lastname_1} ${element.lastname_2}`,
                    type: 'interveners'
                });
            });
        },
        loadAccounts(response) {
            this.results[1].objs = [];
            response.data.accounts.forEach(element => {
                this.results[1].objs.push({
                    uuid: element.uuid,
                    displayName: `${element.id_object}`,
                    tabName: `${element.id_object}`,
                    type: 'accounts'
                });
            });
        },
        loadOperations(response) {
            this.results[2].objs = [];
            response.data.operations.forEach(element => {
                this.results[2].objs.push({
                    uuid: element.uuid,
                    displayName: `${element.id_object}`,
                    tabName: `${element.id_object}`,
                    type: 'operations'
                });
            });
        },
        searchAll(input) {
            clearTimeout(this.timeOutSearch);
            this.searching = true;
            this.timeOutSearch = setTimeout(() => {
                if (input.length > 2) {
                    this.results = [
                        {
                            type: 'Intervinientes',
                            objs: []
                        },
                        {
                            type: 'Cuentas',
                            objs: []
                        },
                        {
                            type: 'Operaciones',
                            objs: []
                        }
                    ];
                    const int_cfg = {
                        params: {
                            $limit: 5
                        }
                    };
                    const acc_cfg = {
                        params: {
                            $limit: 5,
                            $expand: 'interveners',
                            extCodesFromSM: this.allowExternalCodesFromSystemMappings()
                        }
                    };
                    const ope_cfg = {
                        params: {
                            $limit: 5,
                            $expand: 'interveners'
                        }
                    };
                    const q = input.split(' ');
                    if (this.type === '') {
                        const promises = [];
                        promises.push(this.$intervenersService.getSearch(JSON.stringify(q), int_cfg));
                        promises.push(this.$accountsService.getSearch(JSON.stringify(q), acc_cfg));
                        promises.push(this.$operationsService.getSearch(JSON.stringify(q), ope_cfg));
                        Promise.all(promises).then(responses => {
                            this.loadInterveners(responses[0]);
                            this.loadAccounts(responses[1]);
                            this.loadOperations(responses[2]);
                            this.searching = false;
                        });
                    }
                    if (this.type === 'interveners') {
                        this.$intervenersService.getSearch(JSON.stringify(q)).then(response => {
                            this.loadInterveners(response);
                            this.searching = false;
                        });
                    }
                    if (this.type === 'accounts') {
                        this.$accountsService.getSearch(JSON.stringify(q), acc_cfg).then(response => {
                            this.loadAccounts(response);
                            this.searching = false;
                        });
                    }
                    if (this.type === 'operations') {
                        this.$operationsService.getSearch(JSON.stringify(q)).then(response => {
                            this.loadOperations(response);
                            this.searching = false;
                        });
                    }
                } else {
                    this.results = [];
                    this.searching = false;
                }
            }, this.timeOutSearchTime);
        }
    }
};
